// extracted by mini-css-extract-plugin
export default {"container":"SearchInput_container__z+vGn"};